import service from './index'


const resourceAllPromoCodes = service.resource('promo-codes/all{ = search}{ = page}{ = size}{ = sort}')
const removePromoCode = service.resource('promo-codes/{id}')
const createPromoCode = service.resource('promo-codes')

export default {   
  create(data){
    return createPromoCode.save(data)
  },

  getAllPromoCodes(search,page,size) {
    return resourceAllPromoCodes.get({search:search,page:page,size:size,sort:"id,desc"})  
  } , 

  deletePromoCode(id){
    return removePromoCode.delete({id:id})
  },
  
  updatePromoCode(data){
    return createPromoCode.update(data)
  },

}




// WEBPACK FOOTER //
// ./src/services/promoCode.js